import React from "react";
import PropTypes from "prop-types";
import Api from "../../Api";
import "./AdminCollections.less";
import AutoCompleteEditor from "./AutoCompleteEditor.js";
import Button from "../../components/Button";
import FontAwesome from "react-fontawesome";
import ReactDataGrid from "react-data-grid";
import {Toolbar, Formatters} from "react-data-grid-addons";
import DeleteRowContextMenu from "./DeleteRowContextMenu.js";
const {ImageFormatter} = Formatters;

export default class AdminCollectionEdit extends React.Component {
  constructor(props) {
    super(props);

    this.onCollectionActiveChange = this.onCollectionActiveChange.bind(this);
    this.onCollectionNameChange = this.onCollectionNameChange.bind(this);
    this.onCollectionDescriptionChange = this.onCollectionDescriptionChange.bind(this);
    this.onCollectionImageUrlChange = this.onCollectionImageUrlChange.bind(this);

    this.state = {
      brands: null,
      products: null,
      collection: null,
      error: null
    };
  }

  componentDidMount() {
    this.loadCollection();
  }

  loadCollection() {
    Api.getProductCollection(this.props.params.collectionToken).then(
      (collectionsResponse) => {
        let collections = collectionsResponse.product_collections;
        this.setState({
          collection: (collections && collections.length > 0) ? collections[0] : null,
          brands: collectionsResponse.brands,
          products: collectionsResponse.products
        });
      },
      (error) => {
        this.setState({error});
      }
    );
  }

  cancel() {
    this.context.router.push('/admin/collections');
  }

  save() {
    Api.createOrUpdateProductCollection(this.state.collection).then(
      () => {
        this.context.router.push('/admin/collections');
      },
      (error) => {
        alert('Error saving collection: ' + error.message);
      }
    );
  }

  onCollectionActiveChange() {
    let collection = this.state.collection;
    collection.active = !collection.active;
    this.setState({collection: collection});
  }

  onCollectionNameChange(event) {
    let collection = this.state.collection;
    collection.name = event.target.value;
    this.setState({collection: collection});
  }

  onCollectionDescriptionChange(event) {
    let collection = this.state.collection;
    collection.description = event.target.value;
    this.setState({collection: collection});
  }

  onCollectionImageUrlChange(event) {
    let collection = this.state.collection;
    collection.image = {url: event.target.value};
    this.setState({collection: collection});
  }

  render() {
    if (this.state.error) {
      console.error(this.state.error);
      return (<div className="error">Error: {this.state.error.message}</div>);
    }

    if (!this.state.collection) return (<FontAwesome name="refresh" spin/>);

    let collection = this.state.collection;
    let imageUrl = collection.image ? collection.image.url : null;
    return (
      <div className="collection-editor">
        <div>Product Collection Editor</div>
        <form className="collection-editor-form">
          <div className="form-group">
            <label>Active: </label>
            <input ref="active" name="active" type="checkbox" checked={collection.active}
                   onChange={this.onCollectionActiveChange}/>
          </div>
          <div className="form-group">
            <label>Name: </label>
            <input className="input" ref="name" defaultValue={collection.name} placeholder="Name"
                   onChange={this.onCollectionNameChange}/>
          </div>
          <div className="form-group">
            <label>Description: </label>
            <input className="input" ref="description" defaultValue={collection.description}
                   placeholder="Description" onChange={this.onCollectionDescriptionChange}/>
          </div>
          <div className="form-group">
            <label>Image URL: </label>
            <input className="input" ref="image" defaultValue={imageUrl} placeholder="Image URL"
                   onChange={this.onCollectionImageUrlChange}/>
          </div>

          <div>
            <Button onClick={this.save.bind(this)}>Save</Button>
            <Button onClick={this.cancel.bind(this)}>Cancel / Go back</Button>
          </div>
        </form>
        <CollectionItemsGrid
          collection={collection}
          brands={this.state.brands}
          products={this.state.products}
        />
      </div>
    );
  }
}

class CheckmarkFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.any
  };

  render() {
    let className = this.props.value ? 'fa fa-check' : 'fa fa-close';
    return <div> <span className={className}/> </div>;
  }
}

class CollectionItemsGrid extends React.Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    brands: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      collection: props.collection,
      products: props.products,
      brands: props.brands,
      selectedIndexes: []
    };

    this.getColumns = this.getColumns.bind(this);
    this.getAutoCompleteProducts = this.getAutoCompleteProducts.bind(this);
    this.searchProducts = this.searchProducts.bind(this);
    this.searchProductOptions = this.searchProductOptions.bind(this);
    this.getRow = this.getRow.bind(this);
    this.getRowCount = this.getRowCount.bind(this);
    this.onGridRowUpdated = this.onGridRowUpdated.bind(this);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);

    this.takenProductOptionTokens = {};
    props.collection.items.forEach((item) => {
      this.takenProductOptionTokens[item.product_option_token] = true;
    });

    this.columns = [
      {
        key: 'product_name',
        name: 'Product Name',
        width: 300,
        resizable: true,
        editor: <AutoCompleteEditor options={this.getAutoCompleteProducts()}
                                    search={this.searchProducts}
        />
      },
      {
        key: 'product_option',
        name: 'Product Option Name',
        width: 270,
        resizable: true,
        editor: <AutoCompleteEditor options={[]} search={this.searchProductOptions}/>
      },
      {
        key: 'quantity',
        name: 'Quantity',
        width: 90,
        resizable: true,
        editable: true
      },
      {
        key: 'active',
        name: 'Active?',
        width: 75,
        resizable: true,
        formatter: CheckmarkFormatter
      },
      {
        key: 'image_url',
        name: 'Image',
        width: 65,
        resizable: false,
        formatter: ImageFormatter
      },
      {
        key: 'case_size',
        name: 'Case',
        width: 70,
        resizable: true
      },
      {
        key: 'wholesale_price',
        name: 'Wholesale',
        width: 90,
        resizable: true
      },
      {
        key: 'retail_price',
        name: 'Retail',
        width: 90,
        resizable: true
      }
    ];
  }

  getAutoCompleteProducts() {
    let tokens = Object.keys(this.state.products);
    let products = [];
    tokens.forEach(token => {
      let product = this.state.products[token];
      products.push({
        id: product.token,
        value: product,
        text: product.name,
        title: product.name
      });
    });
    return products;
  }

  searchProducts(rowData, currentOptions, searchTerm, callback) {
    if (searchTerm.length < 2) {
      callback(null, this.getAutoCompleteProducts());
      return;
    }

    Api.getProducts(searchTerm, false).then(
      (productsResponse) => {
        let products = [];
        productsResponse.display_order.forEach(productToken => {
          let product = productsResponse.products[productToken];
          products.push({
            id: productToken,
            value: product,
            text: product.name,
            title: product.name
          });
        });
        callback(null, products);
      },
      (error) => {
        alert('Error finding products: ' + error.message);
        callback(null, this.getAutoCompleteProducts());
      }
    );
  }

  searchProductOptions(rowData, currentOptions, searchTerm, callback) {
    let options = [];
    rowData.product.options.forEach(option => {
      if (!this.takenProductOptionTokens[option.token]) {
        options.push({
          id: option.token,
          value: option,
          text: option.name,
          title: option.name
        });
      }
    });
    callback(null, options);
  }

  getColumns() {
    return this.columns;
  }

  getRow(index) {
    let item = this.state.collection.items[index];
    if (!item.product_token) { // Empty new row!
      return {
        product: null,
        product_name: 'Select product',
        product_option: null,
        active: false,
        image_url: '',
        case_size: null,
        wholesale_price: null,
        retail_price: null,
        quantity: null
      };
    }

    let product = this.state.products[item.product_token];
    let productOption = null;
    for (let i = 0; i < product.options.length; i++) {
      if (product.options[i].token === item.product_option_token) {
        productOption = product.options[i];
        break;
      }
    }

    let imageUrl = null;
    if (productOption && productOption.images && productOption.images.length > 0) {
      imageUrl = productOption.images[0].url;
    }
    if (imageUrl === null && product.images && product.images.length > 0) {
      imageUrl = product.images[0].url;
    }
    if (imageUrl === null) {
      for (let i = 0; i < product.options.length; i++) {
        let option = product.options[i];
        if (option.images && option.images.length > 0) {
          imageUrl = option.images[0].url;
          break;
        }
      }
    }

    let caseSize = null;
    let wholesalePrice = null;
    let retailPrice = null;
    if (productOption) {
      caseSize = productOption.unit_multiplier;
      wholesalePrice = '$' + parseFloat(productOption.wholesale_price_cents / 100).toFixed(2);
      retailPrice = '$' + parseFloat(productOption.retail_price_cents / 100).toFixed(2);
    }

    let brand = this.state.brands[item.brand_token];
    let active = product && product.active && brand && brand.active;
    return {
      product: product,
      product_name: product.name || '',
      product_option: productOption ? productOption.name : '',
      active: active,
      image_url: imageUrl || '',
      case_size: caseSize,
      wholesale_price: wholesalePrice,
      retail_price: retailPrice,
      quantity: item.quantity || product.unit_multiplier
    };
  }

  getRowCount() {
    return this.state.collection.items.length;
  }

  onGridRowUpdated({fromRow, toRow, updated}) {
    let collection = this.state.collection;
    let items = collection.items;
    let products = this.state.products;

    let changed = false;
    for (let i = fromRow; i <= toRow; i++) {
      if (updated.quantity) {
        let newQuantity = parseInt(updated.quantity, 10);
        if (items[i].quantity !== newQuantity) {
          items[i].quantity = newQuantity;
          changed = true;
        }
      }

      if (updated.product_name) {
        let product = updated.product_name;
        if (items[i].product_token !== product.token) {

          // Let's see if there are options available for the newly selected product!
          let productOptionToken = null;
          let unitMultiplier = 1;
          for (let i = 0; i < product.options.length; i++) {
            if (!this.takenProductOptionTokens[product.options[i].token]) {
              productOptionToken = product.options[i].token;
              unitMultiplier = product.options[i].unit_multiplier;
              break;
            }
          }

          if (productOptionToken) {
            // Update available product option tokens.
            this.takenProductOptionTokens[items[i].product_option_token] = false;
            this.takenProductOptionTokens[productOptionToken] = true;

            // Update the collection item
            items[i] = {
              token: null,
              product: product,
              product_token: product.token,
              product_option_token: productOptionToken,
              brand_token: product.brand_token,
              quantity: unitMultiplier
            };

            products[product.token] = product;

            changed = true;
          } else {
            alert('All product options for the selected product are already in the collection');
          }
        }
      }

      if (updated.product_option) {
        if (items[i].product_option_token !== updated.product_option.token) {
          // Update available product option tokens.
          this.takenProductOptionTokens[items[i].product_option_token] = false;
          this.takenProductOptionTokens[updated.product_option.token] = true;

          // Update the collection item
          items[i].product_option_token = updated.product_option.token;
          items[i].token = null;

          changed = true;
        }
      }
    }

    if (!changed) return;

    collection.items = items;
    this.setState({
      collection: collection,
      products: products
    });

    Api.createOrUpdateProductCollection(collection).then(
      () => {
      },
      (error) => {
        alert('Error saving collection: ' + error.message);
      }
    );
  }

  addRow() {
    let items = this.state.collection.items;
    items.push({
      product: null,
      product_token: null,
      product_option_token: null,
      brand_token: null,
      quantity: 1
    });
    this.setState({items: items});
  }

  deleteRow(e, {rowIdx}) {
    let collection = this.state.collection;

    // Mark the product option as available
    let productOptionToken = collection.items[rowIdx].product_option_token;
    this.takenProductOptionTokens[productOptionToken] = false;

    // Remove the item from the current items.
    collection.items.splice(rowIdx, 1);
    this.setState({collection: collection});

    Api.createOrUpdateProductCollection(collection).then(
      () => {
      },
      (error) => {
        alert('Error saving collection: ' + error.message);
      }
    );
  }

  render() {
    return (
      <ReactDataGrid
        contextMenu={<DeleteRowContextMenu onRowDelete={this.deleteRow} />}
        columns={this.getColumns()}
        rowGetter={this.getRow}
        rowsCount={this.getRowCount()}
        onGridRowsUpdated={this.onGridRowUpdated}
        toolbar={<Toolbar onAddRow={this.addRow}/>}
        enableCellSelect={true}
        enableRowSelect={false}
        rowHeight={50}
        minHeight={600}
        rowScrollTimeout={200}
      />
    );
  }
}

AdminCollectionEdit.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminCollectionEdit.js
 **/